import { FC } from 'react'
import styles from 'components/features/coaching/advisorLandingPage/CoachCard/CoachCard.styl'
import { AdvisorGrades } from 'components/features/coaching/advisor/AdvisorGrades/AdvisorGrades'
import { Advisor } from 'components/features/coaching/advisor/types/advisor'
import { AdvisorRating } from 'components/features/coaching/advisor/AdvisorRating/AdvisorRating'
import Button from 'components/features/pfm/Button/Button'
import { AdvisorAvatar } from 'components/features/coaching/advisor/AdvisorAvatar/AdvisorAvatar'

type CoachCardProps = {
  advisor: Advisor

}
export const CoachCard: FC<CoachCardProps> = (props) => {
  const { advisor } = props

  return (
    <div className={ styles.coachCard }>
      <div className={ styles.header }>
        <div className={ styles.avatar }>
          <AdvisorAvatar uid={ advisor.uid } />
        </div>
      </div>
      <div className={ styles.content }>
        <div className={ styles.name }>{ advisor.name }</div>
        <div className={ styles.grades }>
          <AdvisorGrades advisor={ advisor } />
        </div>
        <div className={ styles.rating }>
          <AdvisorRating advisor={ advisor } />
        </div>
        <Button fullWidth>SEE REVIEWS</Button>
      </div>
    </div>
  )
}
